import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import agent from './locales/english/agent.json';
import apiKeys from './locales/english/api-keys.json';
import auditLog from './locales/english/audit-log.json';
import auth from './locales/english/auth.json';
import integrations from './locales/english/integrations.json';
import common from './locales/english/common.json';
import credentials from './locales/english/credentials.json';
import drafts from './locales/english/drafts.json';
import inviteUser from './locales/english/invite-user.json';
import navigation from './locales/english/navigation.json';
import onboarding from './locales/english/onboarding.json';
import organization from './locales/english/organization.json';
import automation from './locales/english/automation.json';
import rain from './locales/english/rain.json';
import automationInputs from './locales/english/automation-inputs.json';
import guidance from './locales/english/guidance.json';
import resourcesTranslations from './locales/english/resources.json';
import settings from './locales/english/settings.json';
import theme from './locales/english/theme.json';
import workspace from './locales/english/workspace.json';
import automations from './locales/english/automations.json';
import userProfile from './locales/english/user-profile.json';
import outputs from './locales/english/outputs.json';
import fileRenderer from './locales/english/file-renderer.json';
import chat from './locales/english/chat.json';
import remoteConnections from './locales/english/remote-connections.json';
import browserAutomation from './locales/english/browser-automation.json';
import notifications from './locales/english/notifications.json';
import tours from './locales/english/tours.json';
import resolutionPlaybook from './locales/english/resolution-playbook.json';
import library from './locales/english/library.json';
import finance from './locales/english/finance.json';
import rolesAndAccess from './locales/english/roles-and-access.json';
import agentBuilder from './locales/english/agent-builder.json';
import cartographer from './locales/english/cartographer.json';
import stepWorkbench from './locales/english/step-workbench.json';
import workbench from './locales/english/workbench.json';

const resources = {
  en: {
    agent,
    'api-keys': apiKeys,
    'audit-log': auditLog,
    auth,
    integrations,
    common,
    credentials,
    drafts,
    'invite-user': inviteUser,
    navigation,
    onboarding,
    organization,
    automation,
    rain,
    'automation-inputs': automationInputs,
    guidance,
    resources: resourcesTranslations,
    settings,
    theme,
    workspace,
    automations,
    'user-profile': userProfile,
    outputs,
    'file-renderer': fileRenderer,
    chat,
    'remote-connections': remoteConnections,
    'browser-automation': browserAutomation,
    notifications,
    tours,
    'resolution-playbook': resolutionPlaybook,
    library,
    finance,
    'roles-and-access': rolesAndAccess,
    'agent-builder': agentBuilder,
    cartographer,
    'step-workbench': stepWorkbench,
    workbench,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV && !import.meta.env.VITEST,
    defaultNS: 'common',
    // Only load namespaces that are actively used in the codebase
    // This improves performance by not loading unused translation files
    ns: [
      'agent',
      'api-keys',
      'audit-log',
      'automations',
      'integrations',
      'common',
      'credentials',
      'drafts',
      'guidance',
      'navigation',
      'onboarding',
      'organization',
      'automation',
      'rain',
      'automation-inputs',
      'resources',
      'settings',
      'theme',
      'workspace',
      'user-profile',
      'outputs',
      'file-renderer',
      'chat',
      'remote-connections',
      'browser-automation',
      'notifications',
      'tours',
      'resolution-playbook',
      'library',
      'finance',
      'roles-and-access',
      'agent-builder',
      'cartographer',
      'step-workbench',
      'workbench',
    ],

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    // Enable TypeScript support
    returnNull: false,
    returnEmptyString: false,
    returnObjects: false,
  });

export default i18n;
export * from './utils';
